import requset from "./request";

//获取首页
export function getBookList(data) {
  return requset({
    url: "book/cps/library",
    data,
    method:'POST'
  });
}
//获取书籍详情
export function getBookDetail(data) {
  return requset({
    url: "chapter/cps/read",
    data,
    method:'POST'
  });
}
//获取章节详情
export function getChapterDetail(data) {
  return requset({
    url: "chapter/read",
    data,
    method:'POST'
  });
}